import {
    defaultBaseQuery,
    transformErrorResponse,
    transformSuccessResponse
} from '@/services';
import { createApi } from '@reduxjs/toolkit/query/react';

const departmentLeaveReportAPI = createApi({
    baseQuery: defaultBaseQuery,
    reducerPath: 'departmentLeaveReportAPI',
    endpoints: (builder) => ({

        getListDepartmentLeaveReport: builder.query({
            query: ({ departmentId, page = 0, size = 10, searchText = '', sortDir = 'asc' } = {}) => ({
                url: `/leave-balance/department-report`,
                method: 'GET',
                params: {
                    ...(departmentId && { encryptedDepartmentId: departmentId }),
                    page,
                    size,
                    ...(searchText && { searchText }),
                    ...(sortDir && { sortDir })
                }
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        })
    })
});

export const {
    useLazyGetListDepartmentLeaveReportQuery
} = departmentLeaveReportAPI;

export default departmentLeaveReportAPI;
